import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Configuration from '@/components/Configuration'
import SimpleStart from '@/components/auth/SimpleStart'
import SimpleEnd from '@/components/auth/SimpleEnd'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/config',
      name: 'Configuration',
      component: Configuration
    },
    {
      path: '/simple-start',
      name: 'SimpleStart',
      component: SimpleStart
    },
    {
      path: '/simple-end',
      name: 'SimpleEnd',
      component: SimpleEnd
    }
  ]
})

export default router

Vue.use(Router)



// WEBPACK FOOTER //
// ./src/router/index.js